export default __webpack_public_path__ + "static/chart_1-min-4c518215f9689636cabed46a7d70a260.png";